import React from "react";
import Hello from './Hello.svg'
import LoginForm from "./LoginForm";

const LoginScreen = () => {
    
    
return (
    <div className="authback">
        <div className="hello">
        <img className="hellotext" src={Hello} alt="Hello" />
        <LoginForm />
        </div>
    </div>
)
}

export default LoginScreen;